var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrinterOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3333 11.3333H12.6667C13.0203 11.3333 13.3594 11.1929 13.6095 10.9428C13.8595 10.6928 14 10.3536 14 10V7.33333C14 6.97971 13.8595 6.64057 13.6095 6.39052C13.3594 6.14048 13.0203 6 12.6667 6H3.33333C2.97971 6 2.64057 6.14048 2.39052 6.39052C2.14048 6.64057 2 6.97971 2 7.33333V10C2 10.3536 2.14048 10.6928 2.39052 10.9428C2.64057 11.1929 2.97971 11.3333 3.33333 11.3333H4.66667M6 14H10C10.3536 14 10.6928 13.8595 10.9428 13.6095C11.1929 13.3594 11.3333 13.0203 11.3333 12.6667V10C11.3333 9.64638 11.1929 9.30724 10.9428 9.05719C10.6928 8.80714 10.3536 8.66667 10 8.66667H6C5.64638 8.66667 5.30724 8.80714 5.05719 9.05719C4.80714 9.30724 4.66667 9.64638 4.66667 10V12.6667C4.66667 13.0203 4.80714 13.3594 5.05719 13.6095C5.30724 13.8595 5.64638 14 6 14ZM11.3333 6V3.33333C11.3333 2.97971 11.1929 2.64057 10.9428 2.39052C10.6928 2.14048 10.3536 2 10 2H6C5.64638 2 5.30724 2.14048 5.05719 2.39052C4.80714 2.64057 4.66667 2.97971 4.66667 3.33333V6H11.3333Z",
    stroke: "#09090B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrinterOutline);
export default __webpack_public_path__ + "static/media/PrinterOutline.662647a5f33bb6949255b807d9a476da.svg";
export { ForwardRef as ReactComponent };